/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The lock item spec.
 */
export interface LockItemSpec { 
    /**
     * The lock item details with granular locks
     */
    lock_item?: object;
}

